var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex flex-column"},[_vm._t("label",[_c('label',{class:[
        _vm.$style.infoLabelStyling,
        ' text-body-1 pl-2 font-weight-medium' ]},[_vm._v(" "+_vm._s(_vm.label)+" ")])],{"label":_vm.label}),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }